import { Component, OnInit, Input } from '@angular/core';
import * as firebase from 'firebase';
import { SharedValueService } from '../sharedValue.service';
import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Cursors } from '../item';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import * as moment from 'moment';

@Component({
  selector: 'app-fileupload',
  templateUrl: './fileupload.component.html',
  styleUrls: ['./fileupload.component.css'],
})

export class FileuploadComponent implements OnInit {

  @Input() afAuthChild: AngularFireAuth;
  iconFile: string = 'assets/i-zip.gif';
  private itemsCollection: AngularFirestoreCollection<Cursors>;
  protected strPicture: string = 'http://www.asahi-net.or.jp/~cb9i-kn/img/i-memo.gif';
  viewCursors: Observable<Cursors[]>;

  /** フォームコントロール（追加用） */
  formTitle = new FormControl('');
  formDescription = new FormControl('');
  formImgURL = new FormControl('');
  formZipURL = new FormControl('');
  formZipURLlefty = new FormControl('');

  constructor(private db: AngularFirestore, private sharedValue: SharedValueService) {
    this.itemsCollection = db.collection<Cursors>('itemCursors', ref => ref
    .orderBy('title', 'desc')
    /**.limit(5)*/
    )
  }

  ngOnInit() {
      /** Read: パスにあるドキュメントが変更されるとイベントが発生してデータを参照（ストリームに変換） */
      this.viewCursors = this.itemsCollection.valueChanges();   // データベースから読み込みしている。
  }

  mySelect(event) {

    for(let file of event.files){
      var storageRef = firebase.storage().ref();     // ストレージ参照を作成
      var uploadImagesRef = storageRef.child('cursors/'+file.name);  // アップロードするファイル置き場を指定
      console.log("KANO: メディアタイプ="+file.name.toLowerCase().slice(-3));
      switch (file.name.toLowerCase().slice(-3)) {
        case 'zip':
          var metadata = { contentType: 'application/zip' }; break;
        case 'gif':
          var metadata = { contentType: 'image/gif' }; break;
        case 'png':
          var metadata = { contentType: 'image/png' }; break;
        case 'jpg':
          var metadata = { contentType: 'image/jpg' }; break;
      }

      // ファイルをアップロード。そして進捗とエラー処理
      var uploadTask = uploadImagesRef.put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, function(snapshot) {
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED:
              console.log('KANO: アップロードが中断(Paused)されたよ');
              break;
            case firebase.storage.TaskState.RUNNING:
              console.log('KANO: アップロード中(Running)だよ');
              break;
          }
      }, function(error) {
            // A full list of error codes is available at https://firebase.google.com/docs/storage/web/handle-errors
            console.log('KANO: エラー発生！ code=(' + error.message + ')');
            switch (error.message) {
              case 'storage/unauthorized':
                break;
              case 'storage/canceled':
                break;
              case 'storage/unknown':
                break;
            }
      }, function() {
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            console.log('KANO: ファイルが保存されました<' + downloadURL + '>');
            console.log('KANO: doc.id=' + document.getElementById('TEST').namespaceURI);
            //this.strPicture = "http://www.asahi-net.or.jp/~cb9i-kn/cur/cursor3/img/052fishes.gif";
            var img = document.getElementById('TEST2');
            //img.src = "http://www.asahi-net.or.jp/~cb9i-kn/cur/cursor3/img/052fishes.gif";
            // .strPicture = "http://www.asahi-net.or.jp/~cb9i-kn/cur/cursor3/img/052fishes.gif";
          });
      }); // uploadTask
    } // for
  } // mySelect

  renewPicture(path: string) {
    this.strPicture = path;
  }
  
  /** もしも管理者なら、管理モードになる。 */
  get strKANO() { 
    if(this.sharedValue.strEmail == 'ichiro.kano2@gmail.com') {
      return true;
    } else {
      return false;
    }
  }

  /** Create: データを追加 */
  addItem(): void {
    
    // DBに書き込みする
    const docid = this.db.createId();                      // 新しい投稿なのでドキュメントIDを作成する
    const cursor: Cursors = {
        docid,
        title: this.formTitle.value,
        description: this.formDescription.value,
        imageURL: this.formImgURL.value,
        downloadURL: this.formZipURL.value,
        downloadURLlefty: this.formZipURLlefty.value,
        timestamp: moment().format("YYYY-MM-DD HH:mm:ss"), //作成日時を自動作成する
        count: 0,
    };
    this.itemsCollection.doc(docid).set(cursor);  // データベースに書き込み実行

    // フォームを初期化
    this.formTitle.setValue('');
    this.formDescription.setValue('');
    this.formImgURL.setValue('');
    this.formZipURL.setValue('');
    this.formZipURLlefty.setValue('');
  }

  showNext() {
    this.itemsCollection = this.db.collection<Cursors>('itemCursors', ref => ref
      .orderBy('title', 'desc')
      .limit(200)
    );
    return this.viewCursors = this.itemsCollection.valueChanges();
  }

  countup(strDocId: any, intNumber: number){
    const cursor = {
      count: ++intNumber,
    };
    this.itemsCollection.doc(strDocId).update(cursor);
    console.log('Countup(): '+strDocId +'('+intNumber+')');
  }

} // class FileuploadComponent
